import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const RowLabel = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: ${theme.colors.secondary};
    white-space: normal;
  `}
`

export const IconWrapper = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    color: ${color};
  `}
`

export const AccountIconWrapper = styled(Box)<{ color: string }>`
  ${({ color }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 15px;
    height: 15px;
    color: ${color};

    svg {
      width: 15px !important;
      height: 15px !important;
    }

    & > div {
      min-width: 15px !important;
    }
  `}
`

export const CellWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  white-space: normal;
`

export const CellValue = styled(Box)`
  font-size: 14px;
`

export const CellTrend = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #2a295c;
`

export const DeviationWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  white-space: normal;
`

export const DeviationValue = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 700;
    color: ${theme.colors.primary};
  `}
`

export const DeviationPill = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #283897;
  background: #2838971a;
`

export const WeekHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
  white-space: normal;
`

export const WeekHeaderStatus = styled(Box)`
  display: flex;
  margin-top: 2px;
`

export const GmLabel = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: ${theme.colors.blue.dark};
  `}
`
